<template>
  <MainHeader></MainHeader>
  <div class="flex flex-align-center flex-center">
    <NotFound empty-text="页面找不到..."></NotFound>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from "vue";
import MainHeader from "../common/MainHeader.vue";
import NotFound from "../common/NotFound.vue";
import { useRouter } from "vue-router";
const Router = useRouter();
onMounted(() => {
  setTimeout(() => {
    Router.replace("/");
  }, 2000);
});
</script>
